import styled from 'styled-components'

const LoginPanel = styled.div`
  display: flex;
  margin-top: 10vh;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export default LoginPanel
